import { COUNTRY_MODULES_COLLECTION } from '@app/modules/core/mappers/modules.mapper';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';

const DisabledByDevice = {
  mobile: [],
  desktop: [
    RecentSearchDataType.Cars
  ]
};

export function getRecentSearches(isMobile: boolean, results: RecentSearchModel[]): RecentSearchModel[] {
  return results.filter(result => {
    return !!Object.values(RecentSearchDataType)?.includes(result.datatype) &&
      !isDisabledInDevice(isMobile, result.datatype) && !isDisabledByCountryModule(result.datatype);
  });
}

function isDisabledByCountryModule(dataType: RecentSearchDataType): boolean {
  const modules = COUNTRY_MODULES_COLLECTION;
  return !modules;
}

function isDisabledInDevice(isMobile: boolean, dataType: RecentSearchDataType): boolean {
  const disabledWidgets = isMobile ? DisabledByDevice.mobile : DisabledByDevice.desktop;
  return disabledWidgets.includes(dataType);
}
